<template>
  <div class="Sys-warp">
    <el-breadcrumb class="bread_crumb" separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>{{ businessType == constant.BUSINESS_TYPE_IN ? '企业入驻申请' : '工商变更申请' }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="padding-left: 85px;padding-right: 85px">
      <div class="title" id="title">{{ businessType == constant.BUSINESS_TYPE_IN ? '企业入驻申请' : '工商变更申请' }}</div>
      <el-divider/>
      <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="110px" label-position="right"
               class="demo-ruleForm">

        <el-form-item label="入驻载体" prop="prjBaseInfoId">
          <el-select v-model="formData.prjBaseInfoId" placeholder="请选择入驻载体" style="width: 100%" clearable filterable>
            <el-option v-for="item in projectOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="入驻方式" prop="inType">
          <el-radio-group v-model="formData.inType">
            <el-radio v-for="(item,index) in inTypeOptions" :label="item.key" v-if="item.key!=100">{{
                item.value
              }}
            </el-radio>
          </el-radio-group>
          <div class="tips">
            提示：根据所选，上传购买合同/租赁合同/转租合同
          </div>
        </el-form-item>

        <el-form-item label="申请主体" prop="applyName">
          <el-input v-model="formData.applyName" maxlength="100" class="input" placeholder="请输入申请主体名称"/>
          <div class="tips" v-if="businessType==constant.BUSINESS_TYPE_IN">
            提示：注册新公司须与核名通知书一致；新入驻公司须与营业执照一致
          </div>
        </el-form-item>

        <el-form-item label="是否为个体户" prop="isSelfEmployeed">
          <el-radio-group v-model="formData.isSelfEmployeed">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="产业领域" prop="industrials">
          <el-checkbox-group v-model="formData.industrials">
            <el-checkbox v-for="(item,index) in industrialOptions" :label="item.key" :name="item.value">
              {{ item.value }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="所属类型" prop="periodTypes">
          <el-checkbox-group v-model="formData.periodTypes">
            <el-checkbox v-for="(item,index) in periodTypeOptions" :label="item.key" :name="item.value">
              {{ item.value }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="入驻门牌号" prop="roomNumber">
          <el-input v-model="formData.roomNumber" maxlength="100" class="input" placeholder="请输入入驻场所门牌号"/>
        </el-form-item>
        <el-form-item label="法人代表" prop="legalPerson">
          <el-input v-model="formData.legalPerson" maxlength="100" class="input" placeholder="请输入法人代表名称"/>
        </el-form-item>

        <el-form-item label="经营范围" prop="businessScope">
          <el-input v-model="formData.businessScope" type="textarea" :rows="10" maxlength="800" resize="none"
                    class="input" placeholder="请输入经营范围"/>
        </el-form-item>

        <el-form-item label="注册资本" prop="registeredCapital">
          <el-input v-model="formData.registeredCapital" type="number"

                    maxlength="20" class="input" placeholder="请输入注册资本（单位：万元）">
            <template slot="append">万元</template>
          </el-input>
        </el-form-item>

        <el-form-item label="注册地址" prop="registeredAddress">
          <el-input v-model="formData.registeredAddress" maxlength="220" class="input" placeholder="请输入注册地址"/>
        </el-form-item>

        <el-form-item label="载体面积" prop="squareMeasure">
          <el-input v-model="formData.squareMeasure" type="number"
                    maxlength="20" class="input" placeholder="请输入载体面积（单位：平方米）">
            <template slot="append">平方米</template>
          </el-input>
        </el-form-item>

        <el-form-item label="预计年产值" prop="expectYearValue">
          <el-input v-model="formData.expectYearValue" type="number"
                    maxlength="20" class="input" placeholder="请输入预计年产值（单位：万元）">
            <template slot="append">万元</template>
          </el-input>
        </el-form-item>

        <el-form-item label="预计年税收" prop="expectYearTax">
          <el-input v-model="formData.expectYearTax" type="number"
                    maxlength="20" class="input" placeholder="请输入预计年税收（单位：万元）">
            <template slot="append">万元</template>
          </el-input>
        </el-form-item>

        <el-form-item label="员工人数" prop="numberOfEmployees">
          <el-input v-model="formData.numberOfEmployees" maxlength="9"   oninput="value=value.replace(/[^\d]/g,'')" class="input" placeholder="请输入员工数量"/>
        </el-form-item>

        <el-form-item label="联系人姓名" prop="contact">
          <el-input v-model="formData.contact" maxlength="100" class="input" placeholder="请输入联系人姓名"/>
        </el-form-item>

        <el-form-item label="联系人电话" prop="contactPhone">
          <el-input v-model="formData.contactPhone" maxlength="11" class="input" placeholder="请输入联系人手机号码"/>
        </el-form-item>



        <el-form-item label="核名通知书 /营业执照" prop="companyLicenseFiles" v-if="formData.isSelfEmployeed!=1">
          <div class="image-hint"><i class="el-icon-info"/>支持jpg/jpeg/png/bmp图片
            附件数量:{{ formData.companyLicenseFiles.length }}/3
          </div>
          <div class="img-container">
            <el-popover
                placement="bottom"
                v-for="(item,index) in formData.companyLicenseFiles"
                trigger="hover">
              <div style="display: flex;justify-content: center">
                <el-link @click="formData.companyLicenseFiles.splice(index,1)" type="danger">移除<i
                    class="el-icon-delete el-icon--right"></i></el-link>
              </div>
              <el-image
                  slot="reference"
                  class="img"
                  @click="handlePictureCardPreview(item)"
                  :src="item.url">
              </el-image>
            </el-popover>
            <el-upload
                :multiple="true"
                class="upload"
                v-if="formData.companyLicenseFiles.length<3"
                :action="'aa'"
                ref="companyFileUpload"
                :on-exceed="onExceed"
                :limit="3"
                :http-request="(data) =>  { return uploadFile(data, constant.CONST_COMPANY_LICENSE_FILE_TYPE)}"
                :with-credentials="true"
                list-type="picture-card"
                accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP"
                :before-upload=" (file) =>  { return beforeUpload(file, constant.CONST_COMPANY_LICENSE_FILE_TYPE)}">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-form-item>

          <el-form-item label="法人证件照" prop="legalPersonFiles">
            <div class="image-hint"><i class="el-icon-info"/>支持jpg/jpeg/png/bmp图片
              附件数量:{{ formData.legalPersonFiles.length }}/2
            </div>
            <div class="tips" style="margin-top: 0px;margin-bottom: 10px">
              提示：身份证正、反两面
            </div>
            <div class="img-container">
              <el-popover
                  placement="bottom"
                  v-for="(item,index) in formData.legalPersonFiles"
                  trigger="hover">
                <div style="display: flex;justify-content: center">
                  <el-link @click="formData.legalPersonFiles.splice(index,1)" type="danger">移除<i
                      class="el-icon-delete el-icon--right"></i></el-link>
                </div>
                <el-image
                    slot="reference"
                    class="img"
                    @click="handlePictureCardPreview(item)"
                    :src="item.url">
                </el-image>
              </el-popover>
              <el-upload
                  :multiple="true"
                  class="upload"
                  v-if="formData.legalPersonFiles.length<2"
                  :action="'aa'"
                  ref="legalPersonFileUpload"
                  :on-exceed="onExceed"
                  :limit="2"
                  :http-request="(data) =>  { return uploadFile(data, constant.CONST_LEGAL_PERSON_FILE_TYPE)}"
                  :with-credentials="true"
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP"
                  :before-upload=" (file) =>  { return beforeUpload(file, constant.CONST_LEGAL_PERSON_FILE_TYPE)}">
                <i class="el-icon-plus"></i>
              </el-upload>
            </div>
          </el-form-item>

        <el-form-item label="购买合同/租赁合同/转租合同" prop="rentContractFiles">
          <div class="image-hint"><i class="el-icon-info"/>支持jpg/jpeg/png/bmp图片
            附件数量:{{ formData.rentContractFiles.length }}/20
          </div>
          <div class="img-container">
            <el-popover
                placement="bottom"
                v-for="(item,index) in formData.rentContractFiles"
                trigger="hover">
              <div style="display: flex;justify-content: center">
                <el-link @click="formData.rentContractFiles.splice(index,1)" type="danger">移除<i
                    class="el-icon-delete el-icon--right"></i></el-link>
              </div>
              <el-image
                  slot="reference"
                  class="img"
                  @click="handlePictureCardPreview(item)"
                  :src="item.url">
              </el-image>
            </el-popover>
            <el-upload
                :multiple="true"
                class="upload"
                v-if="formData.rentContractFiles.length<20"
                :action="'aa'"
                ref="rentContractFileUpload"
                :on-exceed="onExceed"
                :limit="20"
                :http-request="(data) =>  { return uploadFile(data, constant.CONST_RENT_CONTRACT_FILE_TYPE)}"
                :with-credentials="true"
                list-type="picture-card"
                accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP"
                :before-upload=" (file) =>  { return beforeUpload(file, constant.CONST_RENT_CONTRACT_FILE_TYPE)}">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-form-item>

        <el-form-item label="全部股东证件照片（身份证或营业执照）" prop="shareholdersFiles" v-if="formData.registeredCapital>=1000">
          <div class="image-hint"><i class="el-icon-info"/>支持jpg/jpeg/png/bmp图片
            附件数量:{{ formData.shareholdersFiles.length }}/20
          </div>
          <div class="img-container">
            <el-popover
                placement="bottom"
                v-for="(item,index) in formData.shareholdersFiles"
                trigger="hover">
              <div style="display: flex;justify-content: center">
                <el-link @click="formData.shareholdersFiles.splice(index,1)" type="danger">移除<i
                    class="el-icon-delete el-icon--right"></i></el-link>
              </div>
              <el-image
                  slot="reference"
                  class="img"
                  @click="handlePictureCardPreview(item)"
                  :src="item.url">
              </el-image>
            </el-popover>
            <el-upload
                :multiple="true"
                class="upload"
                v-if="formData.shareholdersFiles.length<20"
                :action="'aa'"
                ref="shareHoldersFileUpload"
                :on-exceed="onExceed"
                :limit="20"
                :http-request="(data) =>  { return uploadFile(data, constant.CONST_SHARE_HOLDERS_FILE_TYPE)}"
                :with-credentials="true"
                list-type="picture-card"
                accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP"
                :before-upload=" (file) =>  { return beforeUpload(file, constant.CONST_SHARE_HOLDERS_FILE_TYPE)}">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="其他证明文件" prop="otherFiles">
          <div class="image-hint"><i class="el-icon-info"/>支持jpg/jpeg/png/bmp图片
            附件数量:{{ formData.otherFiles.length }}/20
          </div>
          <div class="tips" style="margin-top: 0px;margin-bottom: 10px">
            提示：企业场地划拨证明等、办理资质审核需提交的其他文件
          </div>
          <div class="img-container">
            <el-popover
                placement="bottom"
                v-for="(item,index) in formData.otherFiles"
                trigger="hover">
              <div style="display: flex;justify-content: center">
                <el-link @click="formData.otherFiles.splice(index,1)" type="danger">移除<i
                    class="el-icon-delete el-icon--right"></i></el-link>
              </div>
              <el-image
                  slot="reference"
                  class="img"
                  @click="handlePictureCardPreview(item)"
                  :src="item.url">
              </el-image>
            </el-popover>
            <el-upload
                :multiple="true"
                class="upload"
                v-if="formData.otherFiles.length<20"
                :action="'aa'"
                ref="otherFileUpload"
                :on-exceed="onExceed"
                :limit="20"
                :http-request="(data) =>  { return uploadFile(data, constant.CONST_OHTER_ATTACHEMENT_FILE_TYPE)}"
                :with-credentials="true"
                list-type="picture-card"
                accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP"
                :before-upload=" (file) =>  { return beforeUpload(file, constant.CONST_OHTER_ATTACHEMENT_FILE_TYPE)}">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </el-form-item>


        <el-form-item>
          <div style="display: flex">
            <el-button style="flex-grow: 3" type="primary" @click="submitForm('ruleForm')">提交</el-button>
            <el-button style="flex-grow: 1" @click="resetForm('ruleForm')">重置</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>


    <!--    预览图片的dialog-->
    <el-dialog :visible.sync="previewImgDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>

    <!--    阅读告知书的dialog-->
    <el-dialog
        title="入驻须知"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="readNoticeVisible"
        width="1000px">

      <img width="100%" :src="noticePicUrl" alt="">
      <div style="display: flex;justify-content: center;margin-top: 20px;margin-bottom: 20px">
        <el-checkbox v-model="agreeNotice" @change="onAgreeChange" style=" transform : scale(1.1)">法人已阅读并同意以上内容
        </el-checkbox>
      </div>
      <div style="display: flex;justify-content: center" v-if="showSign" id="signContainer">
        <sign ref="sign"></sign>
      </div>
      <span slot="footer" class="dialog-footer">
            <el-button @click="onCancelNotice">取 消</el-button>
            <el-button type="primary" @click="onConfirmNotice">确 定</el-button>
          </span>
    </el-dialog>

    <!--提交成功的弹窗-->
    <el-dialog
        title="审批申请提交成功"
        width="500px"
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :visible.sync="submitSuccessVisible">

      <div>
        <!--        <div style="display: flex"><span style="font-size: 16px">申请编号：{{-->
        <!--            successData.no-->
        <!--          }}{{ successData.applyNo }}</span>-->
        <!--          <div style="font-size: 20px">-->
        <!--            <i class="el-icon-document-copy" @click="copyApplyNo" style="margin-left: 20px;cursor: pointer;"></i>-->
        <!--          </div>-->
        <!--        </div>-->
        <div>
          可在网站或小程序中使用联系人手机号{{ this.formData.contactPhone }}查询审批进度
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
                   <el-button type="primary" @click="jumpToHome">我知道了</el-button>
          </span>
    </el-dialog>

    <!--告知应由法人签名的dialog-->
    <el-dialog
        title="告知提醒"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="signNoticeVisible"
        width="500px">
      <p style="font-size: large">认真阅读入驻告知书后，请由法人亲自签名</p>
      <span slot="footer" class="dialog-footer">
            <el-button @click="agreeNotice = false;signNoticeVisible = false">取 消</el-button>
            <el-button type="primary" @click="onConfirmSignNotice"
                       :disabled="confirmSignNoticeCountDown!=0">确 定{{
                confirmSignNoticeCountDown == 0 ? '' : '(' + confirmSignNoticeCountDown + ')'
              }}</el-button>
          </span>
    </el-dialog>
  </div>
</template>

<script>

import {
  getEnumByClassName,
  getProjectOptions, inApply,
  uploadFileToBaiduCloud,
  getInApplyNoticePicUrl, getApplyInfo,
  getEnterpriseInfo
} from "@/api/api";
import util, {base64toFile} from "@/utils/util"
import constant from "@/utils/constant"
import sign from "@/component/sign"

var validPhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error('请输入电话号码'))
  } else if (!util.checkMobile(value)) {
    callback(new Error('请输入正确的11位手机号码'))
  } else {
    callback()
  }
}

export default {
  name: 'InApply',
  components: {
    sign
  },

  data() {
    return {
      timer: null,
      businessType: constant.BUSINESS_TYPE_IN,
      enterpriseId: null, //变更审批进来的时候，如果企业存在，则有这个企业ID
      showSign: false,
      submitSuccessVisible: false,
      signNoticeVisible: false,
      agreeNotice: false,
      constant: constant,
      previewImgDialogVisible: false,
      readNoticeVisible: false,
      dialogImageUrl: null,
      applyId: null,
      projectOptions: [],
      inTypeOptions: [],
      industrialOptions: [],
      periodTypeOptions: [],
      noticePicUrl: '',
      confirmSignNoticeCountDown: 10,
      signFileName: null,
      successData: {
        no: '',
        applyNo: ''
      },
      formData: {
        applyName: '',
        numberOfEmployees:'',
        isSelfEmployeed: 0,
        prjBaseInfoId: null,
        inType: null,
        roomNumber: '',
        legalPerson: '',
        businessScope: '',
        registeredCapital: '',
        registeredAddress: '',
        squareMeasure: '',
        expectYearValue: '',
        expectYearTax: '',
        contact: '',
        contactPhone: '',
        industrials: [],
        periodTypes: [],
        companyLicenseFiles: [], //营业执照，核名通知书
        legalPersonFiles: [], //法人身份证照片
        rentContractFiles: [], //租赁合同照片
        shareholdersFiles: [], //股东证件
        otherFiles: [], //其他证明文件
      },
      rules: {
        prjBaseInfoId: [
          {required: true, message: '请选择入驻载体', trigger: 'change'},
        ],
        applyName: [
          {required: true, message: '请输入主体名称', trigger: 'change'},
        ],
        inType: [
          {required: true, message: '请选择入驻方式', trigger: 'change'},
        ],
        isSelfEmployeed: [
          {required: true, message: '请选择是否为个体户', trigger: 'change'},
        ],
        industrials: [
          {type: 'array', required: true, message: '请至少选择一个产业领域', trigger: 'change'}
        ],
        periodTypes: [
          {type: 'array', required: true, message: '请至少选择一个所属类型', trigger: 'change'}
        ],
        roomNumber: [
          {required: true, message: '请输入入驻场所门牌号', trigger: 'change'},
        ],
        legalPerson: [
          {required: true, message: '请输入法人代表名称', trigger: 'change'},
        ],
        businessScope: [
          {required: true, message: '请输入经营范围', trigger: 'change'},
        ],
        registeredCapital: [
          {required: true, message: '请输入注册资本', trigger: 'change'},
        ],
        registeredAddress: [
          {required: true, message: '请输入注册地址', trigger: 'change'},
        ],
        squareMeasure: [
          {required: true, message: '请输入载体面积', trigger: 'change'},
        ],
        expectYearValue: [
          {required: true, message: '请输入预计年产值', trigger: 'change'},
        ],
        expectYearTax: [
          {required: true, message: '请输入预计年税收', trigger: 'change'},
        ],
        numberOfEmployees: [
          {required: true, message: '请输入员工数量', trigger: 'change'},
        ],
        contact: [
          {required: true, message: '请输入联系人名称', trigger: 'change'},
        ],
        contactPhone: [
          {required: true, validator: validPhone, trigger: 'change'},
        ],
        companyLicenseFiles: [
          {type: 'array', required: true, message: '请上传核名通知书/营业执照', trigger: 'change'},
        ],
        legalPersonFiles: [
          {type: 'array', required: true, message: '请上传法人证件照', trigger: 'change'},
        ],
        rentContractFiles: [
          {type: 'array', required: true, message: '请上传租赁合同照片', trigger: 'change'},
        ],
        shareholdersFiles: [
          {type: 'array', required: true, message: '请上传全部股东证件', trigger: 'change'},
        ],
      }
    };
  },
  watch: {
    $route(to, from) {
      this.initData()
    }
  },
  created() {
    this.$nextTick(() => {
      this.initData();
    })
  },
  methods: {
    initData() {
      let path = this.$route.path
      if (path.indexOf('Change') != -1) {
        this.businessType = constant.BUSINESS_TYPE_CHANGE
      } else {
        this.businessType = constant.BUSINESS_TYPE_IN
      }
      this.applyId = this.$route.params.id
      if (this.$route.params.enterpriseId) {
        this.enterpriseId = this.$route.params.enterpriseId
      }
      if (this.applyId != null && this.applyId == 0) {
        this.applyId = null;
      }
      if (this.enterpriseId != null && this.enterpriseId == 0) {
        this.enterpriseId = null;
      }
      this.agreeNotice = false
      this.resetForm('ruleForm')
      let companyName = this.$route.params.companyName;
      if (companyName != null && companyName.length != 0 && companyName != '0') {
        this.formData.applyName = companyName
      }
      if (this.businessType == constant.BUSINESS_TYPE_IN) {
        this.readNoticeVisible = true
      }
      console.log('this.applyId=' + this.applyId + ",this.enterpriseId=" + this.enterpriseId)
      getInApplyNoticePicUrl().then(res => {
        if (res.code == 0) {
          this.noticePicUrl = res.data;
        }
      })
      getProjectOptions().then(res => {
        this.projectOptions = res.data
        getEnumByClassName('EnumInApplyType').then(res => {
          this.inTypeOptions = res.list;
          getEnumByClassName('EnumInApplyIndustrial').then(res => {
            this.industrialOptions = res.list;
            getEnumByClassName('EnumInApplyPeriodType').then(res => {
              this.periodTypeOptions = res.list;
              if (this.applyId != null) {
                this.getApplyInfo()
              } else if (this.enterpriseId != null) {
                this.getEnterpriseInfo()
              } else {

              }
            })
          })
        })
      })
    },
    getEnterpriseInfo() {
      getEnterpriseInfo(this.enterpriseId).then(res => {
        if (res.code == 0) {
          let data = res.data;
          data.applyName = data.name;
          this.handleServerData(data)
        }
      })
    },
    getApplyInfo() {
      getApplyInfo(this.applyId).then(res => {
        if (res.code == 0) {
          let data = res.data.prjInApply;
          if (data.enterpriseId != null) {
            this.enterpriseId = data.enterpriseId
          }
          console.log("enterpriseId=" + this.enterpriseId)
          this.handleServerData(data)
        } else {
          this.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.jumpToHome()
            }
          });
        }
      })
    },
    handleServerData(data) {
      this.formData.applyName = data.applyName
      this.formData.prjBaseInfoId = data.prjBaseInfoId
      this.formData.inType = data.inType
      this.formData.legalPerson = data.legalPerson
      this.formData.roomNumber = data.roomNumber
      this.formData.businessScope = data.businessScope
      this.formData.registeredCapital = data.registeredCapital
      this.formData.registeredAddress = data.registeredAddress
      this.formData.squareMeasure = data.squareMeasure
      this.formData.expectYearValue = data.expectYearValue
      this.formData.expectYearTax = data.expectYearTax
      this.formData.contact = data.contact
      this.formData.contactPhone = data.contactPhone
      this.formData.numberOfEmployees = data.numberOfEmployees

      for (var i = 0; i < data.attachmentList.length; i++) {
        let attachment = data.attachmentList[i]
        let value = {
          "name": attachment.ossFileName,
          "url": attachment.url
        }
        if (attachment.type == constant.CONST_COMPANY_LICENSE_FILE_TYPE) {
          this.formData.companyLicenseFiles.push(value);
        } else if (attachment.type == constant.CONST_LEGAL_PERSON_FILE_TYPE) {
          this.formData.legalPersonFiles.push(value);
        } else if (attachment.type == constant.CONST_RENT_CONTRACT_FILE_TYPE) {
          this.formData.rentContractFiles.push(value);
        } else if (attachment.type == constant.CONST_SHARE_HOLDERS_FILE_TYPE) {
          this.formData.shareholdersFiles.push(value);
        } else if (attachment.type == constant.CONST_OHTER_ATTACHEMENT_FILE_TYPE) {
          this.formData.otherFiles.push(value);
        }
      }


      if (this.formData.companyLicenseFiles.length == 0) {
        this.formData.isSelfEmployeed = 1
      } else {
        this.formData.isSelfEmployeed = 0
      }

      // 处理产业领域框选
      for (var i = 0; i < this.industrialOptions.length; i++) {
        let item = this.industrialOptions[i]
        for (var j = 0; j < data.industrialList.length; j++) {
          let industrial = data.industrialList[j]
          if (item.key == industrial.industrial) {
            this.formData.industrials.push(item.key)
          }
        }
      }

      //处理所属类型框选
      for (var i = 0; i < this.periodTypeOptions.length; i++) {
        let item = this.periodTypeOptions[i]
        for (var j = 0; j < data.peridList.length; j++) {
          let peridList = data.peridList[j]
          if (item.key == peridList.period) {
            this.formData.periodTypes.push(item.key)
          }
        }
      }

    },
    beforeUpload(file, type) {
      let extension = util.getFileExtName(file.name)
      if (extension !== 'jpg' && extension != 'jpeg' && extension != 'png') {
        this.$message.error('请上传png、jpg、jpeg格式图片')
        return false
      }
      this.uploadFile(file, type)
      return false
    },
    uploadFile(file, type) {
      console.log("uploadFile.type=" + type)
      console.log(file)
      let fileList = this.getFileListByType(type);
      let _this = this;
      uploadFileToBaiduCloud(file, function (success) {
        console.log("upload success =" + JSON.stringify(success))
        fileList.push(success)
      }, function (fail) {
        _this.$message.error('上传失败')
      })
    },
    getFileListByType(type) {
      let fileList;
      if (type == constant.CONST_COMPANY_LICENSE_FILE_TYPE) {
        fileList = this.formData.companyLicenseFiles;
      } else if (type == constant.CONST_LEGAL_PERSON_FILE_TYPE) {
        fileList = this.formData.legalPersonFiles;
      } else if (type == constant.CONST_RENT_CONTRACT_FILE_TYPE) {
        fileList = this.formData.rentContractFiles;
      } else if (type == constant.CONST_SHARE_HOLDERS_FILE_TYPE) {
        fileList = this.formData.shareholdersFiles;
      } else if (type == constant.CONST_OHTER_ATTACHEMENT_FILE_TYPE) {
        fileList = this.formData.otherFiles;
      }
      return fileList;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.previewImgDialogVisible = true;
    },
    handleRemove(file, type) {
      // console.log('handleRemove.type=' + type)
      // console.log('file=' + JSON.stringify(file))
      // file = file.response
      // let fileList = this.getFileListByType(type);
      // for (let i = fileList.length - 1; i >= 0; i--) {
      //   if (file.url == fileList[i].url) {
      //     fileList.splice(i, 1)
      //   }
      // }
      // console.log("fileList=" + JSON.stringify(fileList))
    },
    onExceed() {
      this.$message.error("已超过最大文件数")
    },
    getCurrentProjectM2TaxRequirement() {
      for (var i = 0; i < this.projectOptions.length; i++) {
        let project = this.projectOptions[i];
        if (project.id == this.formData.prjBaseInfoId) {
          return project.perM2TaxRequirement;
        }
      }
    },
    getFiles(refs) {
      let fileList = []
      if (this.$refs[refs] != undefined) {
        fileList = this.$refs[refs].uploadFiles
      }
      console.log(refs + ".fileList=" + JSON.stringify(fileList));
      let resultList = [];
      for (let i = 0; i < fileList.length; i++) {
        let file = fileList[i];
        if (file.status === 'success') {
        }
        let resultFile = file.response
        resultList.push(resultFile)
      }
      return resultList
    },
    submitForm(formName) {


      // this.formData.companyLicenseFiles = this.getFiles('companyFileUpload')
      // this.formData.legalPersonFiles = this.getFiles('legalPersonFileUpload')
      // this.formData.rentContractFiles = this.getFiles('rentContractFileUpload')
      // this.formData.shareholdersFiles = this.getFiles('shareHoldersFileUpload')

      console.log("营业执照=" + JSON.stringify(this.formData.companyLicenseFiles))
      console.log("法人证件=" + JSON.stringify(this.formData.legalPersonFiles))
      console.log("租赁合同=" + JSON.stringify(this.formData.rentContractFiles))
      console.log("股东证件=" + JSON.stringify(this.formData.shareholdersFiles))
      console.log("其他证明文件=" + JSON.stringify(this.formData.otherFiles))
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('formData=' + JSON.stringify(this.formData))
          //计算是否达到平方米税收标准
          //用年税收，单位万元，除以占地面积，因为服务端门槛是元为单位，所以这里先把单位转换为元
          let userPerM2TaxRequirement = this.formData.expectYearTax * 10000 / this.formData.squareMeasure;
          userPerM2TaxRequirement = userPerM2TaxRequirement.toFixed(2);
          console.log("userPerM2TaxRequirement=" + userPerM2TaxRequirement);
          let projectPerM2TaxRequirement = this.getCurrentProjectM2TaxRequirement();
          console.log("projectPerM2TaxRequirement=" + projectPerM2TaxRequirement);

          let isReachTheThreshold;
          if (userPerM2TaxRequirement >= projectPerM2TaxRequirement) {
            isReachTheThreshold = true;
          } else {
            isReachTheThreshold = false;
          }
          if (!isReachTheThreshold) {
            this.showConfirmPop()
            // let projectM2TaxRequirementStr = "每平方米" + projectPerM2TaxRequirement + "元";
            // let userM2TaxRequirementStr = "每平方米" + userPerM2TaxRequirement + "元";
            // console.log("没达到税收标准")
            // // let msg = '该载体税收门槛为：' + projectM2TaxRequirementStr + '。您的预计税收为：' + userM2TaxRequirementStr + '。是否继续提交？'
            // let msg = '未达到税收门槛，是否继续提交？'
            // this.$confirm(msg, '温馨提示', {
            //   confirmButtonText: '确定',
            //   cancelButtonText: '取消',
            //   type: 'warning',
            //   closeOnClickModal: false
            // }).then(() => {
            //   this.showConfirmPop()
            // }).catch(() => {
            // });
          } else {
            console.log("达到了税收标准")
            this.showConfirmPop()
          }
        } else {
          return false;
        }
      });
    },
    showConfirmPop() {
      this.$confirm('请确认联系人手机号：' + this.formData.contactPhone + '，该手机号将用于查询审批进度，确认无误后点击确定提交审批申请。', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.submitToServer()
      }).catch(() => {
      });
    },
    //取消阅读入驻告知书，跳转回首页
    onCancelNotice() {
      this.jumpToHome()
    },
    //确认同意阅读告知书后
    onConfirmNotice() {
      if (!this.agreeNotice) {
        this.$message.error("请法人先阅读并同意《入驻告知书》")
        return
      }
      let imgUrl = this.$refs.sign.commit();
      if (imgUrl == null) {
        this.$message.error("请进行签名")
        return
      }
      let f = util.base64toFile(imgUrl);
      let _this = this
      uploadFileToBaiduCloud(f, function (success) {
        console.log("upload success =" + JSON.stringify(success))
        _this.signFileName = success.name
        // _this.submitToServer()
        _this.readNoticeVisible = false
        _this.$nextTick(() => {
          document.getElementById('title').scrollIntoView()
        })
      }, function (fail) {
        _this.$message.error('上传签名失败，请联系管理员')
      }, true)
    },
    submitToServer() {
      //封装附件
      let fileList = [];


      //签名文件
      let signFile = {
        type: constant.CONST_COMPANY_APPLY_SIGN_FILE_TYPE,
        url: this.signFileName
      }
      fileList.push(signFile);
      //营业执照，核名通知书
      if (this.formData.isSelfEmployeed != 1) {
        for (var i = 0; i < this.formData.companyLicenseFiles.length; i++) {
          let item = this.formData.companyLicenseFiles[i];
          let file = {
            type: constant.CONST_COMPANY_LICENSE_FILE_TYPE,
            url: item.name
          }
          fileList.push(file);
        }
      }
      //法人证件照片
      for (var i = 0; i < this.formData.legalPersonFiles.length; i++) {
        let item = this.formData.legalPersonFiles[i];
        let file = {
          type: constant.CONST_LEGAL_PERSON_FILE_TYPE,
          url: item.name
        }
        fileList.push(file);
      }
      //租赁合同照片
      for (var i = 0; i < this.formData.rentContractFiles.length; i++) {
        let item = this.formData.rentContractFiles[i];
        let file = {
          type: constant.CONST_RENT_CONTRACT_FILE_TYPE,
          url: item.name
        }
        fileList.push(file);
      }
      //全部股东证件
      if (this.formData.registeredCapital >= 1000) {
        for (var i = 0; i < this.formData.shareholdersFiles.length; i++) {
          let item = this.formData.shareholdersFiles[i];
          let file = {
            type: constant.CONST_SHARE_HOLDERS_FILE_TYPE,
            url: item.name
          }
          fileList.push(file);
        }
      }
      //其他证明文件
      for (var i = 0; i < this.formData.otherFiles.length; i++) {
        let item = this.formData.otherFiles[i];
        let file = {
          type: constant.CONST_OHTER_ATTACHEMENT_FILE_TYPE,
          url: item.name
        }
        fileList.push(file);
      }
      console.log("附件：" + JSON.stringify(fileList))
      let industrials = this.formData.industrials.join(',');
      let periodTypes = this.formData.periodTypes.join(',');
      const loading = this.$loading({
        lock: true,
        text: '请稍候',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let _this = this
      inApply(this.formData.applyName, this.formData.prjBaseInfoId, this.formData.inType, this.formData.roomNumber, industrials,
          periodTypes, this.formData.legalPerson, this.formData.businessScope, this
              .formData.registeredCapital, this.formData.registeredAddress, this.formData.squareMeasure, this
              .formData.expectYearValue, this.formData.expectYearTax, this.formData.contact, this.formData
              .contactPhone, fileList, this.businessType, this.enterpriseId,this.formData.numberOfEmployees).then(res => {
        loading.close()
        console.log('inapply.result=' + JSON.stringify(res))
        if (res.code == 0) {
          //成功
          _this.successData = res.data
          _this.submitSuccessVisible = true
        } else {
          //失败
          _this.$alert(res.msg, '失败', {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      // if (this.$refs['companyFileUpload'] != undefined) {
      //   this.$refs['companyFileUpload'].clearFiles();
      // }
      // this.$refs['legalPersonFileUpload'].clearFiles();
      // this.$refs['rentContractFileUpload'].clearFiles();
      //
      // if (this.$refs['shareHoldersFileUpload'] != undefined) {
      //   this.$refs['shareHoldersFileUpload'].clearFiles();
      // }
      if (this.$refs['sign'] != undefined) {
        this.$refs['sign'].overwrite();
      }
    },
    copyApplyNo() {
      let _this = this
      let str = this.successData.no.toString() + this.successData.applyNo.toString()
      this.$copyText(str).then(function (e) {
        console.log('复制成功', e.text)
        _this.$message.success("复制成功")
      }, function (e) {
        console.log(e)
        console.log('不能复制，复制失败')
        _this.$message.error("复制失败，请手动复制")
      })
    },
    jumpToHome() {
      this.$router.replace({
        name: 'home'
      });
    },
    // 当是否同意checkbox被勾选或取消时
    onAgreeChange(value) {
      if (value) {
        this.signNoticeVisible = true
        this.clearTimer()
        this.confirmSignNoticeCountDown = 10;
        if (!this.timer) {
          this.timer = setInterval(() => {
            if (this.confirmSignNoticeCountDown > 0) {
              this.confirmSignNoticeCountDown--;
            } else {
              this.clearTimer();
            }
          }, 1000)
        }
      } else {
        this.showSign = false
      }
    },
    clearTimer() {
      clearInterval(this.timer);
      this.timer = null;
    },
    onConfirmSignNotice() {
      this.signNoticeVisible = false
      this.showSign = true;
      this.$nextTick(() => {
        document.getElementById('signContainer').scrollIntoView()
      })
    }
  }
  ,
}
</script>
<style scoped>
.img {
  width: 147px;
  height: 147px;
  margin-right: 20px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.upload {
  display: inline-flex;
}

.input {
  width: 100%
}
</style>
